/**
 * antd 主题种子（明 / 暗两套）—— **唯一来源**。
 *
 * 为什么单独抽出：
 *   1. `scripts/gen-antd-dark-tokens.cjs` 用它：暗色 CSS 变量层必须按**这两套种子**
 *      （而不是 antd 原生算法值）算出「亮暗取值不同的 token」有哪些，否则生成出来的
 *      暗色与现网逐字不同；
 *   2. 亮色那一套同时是 `src/app.tsx` 运行时 ConfigProvider 的种子（算法固定亮色）。
 *      暗色那一套**不再喂给运行时**（切算法已取消），只作为上面第 1 条的对照基准。
 *      抽成模块就是为了**避免两处各写一份、日后漂移**。
 *
 * 取值来源：`D:\dy-maritime-style\docs\prototype\system-prototype.html`
 *   （亮 :root / 暗 :root.dark），与 `src/styles/tokens.css` 的主题语义色层**同源**：
 *   colorBgContainer 暗 == --bg-surface 暗 == #16171F，colorText 暗 == --text-1 暗 == #E6E8EF …
 *   （生成器会逐条校验这一点，不等价的自动回退成字面量。）
 *
 * ⚠️ 改这里的值 = 改全站观感；改完必须重跑 `node scripts/gen-antd-dark-tokens.cjs`。
 */
import type { ThemeConfig } from 'antd';

/** 亮色种子（= 现网亮色外观） */
export const LIGHT_SEEDS: ThemeConfig['token'] = {
  colorBgBase: '#F7F8FA',
  colorBgLayout: '#F7F8FA',
  colorBgContainer: '#FFFFFF',
  colorBgElevated: '#FFFFFF',
  colorText: '#1A1D27',
  colorTextSecondary: '#5A6070',
  colorTextTertiary: '#8C93A3',
  colorTextQuaternary: '#AEB4C4',
  colorBorder: '#EAECF2',
  colorBorderSecondary: '#F2F3F7',
  colorPrimary: '#1B6FE8',
  colorSuccess: '#15A05A',
  colorWarning: '#D98A00',
  colorError: '#E0413B',
  colorInfo: '#2E7BE5',
};

/** 暗色种子（= 现网暗色外观；与 tokens.css 的 [data-theme="dark"] 层逐字同源） */
export const DARK_SEEDS: ThemeConfig['token'] = {
  colorBgBase: '#0E0F15',
  colorBgLayout: '#0E0F15',
  colorBgContainer: '#16171F',
  colorBgElevated: '#16171F',
  colorText: '#E6E8EF',
  colorTextSecondary: '#9BA2B3',
  colorTextTertiary: '#6B7280',
  colorTextQuaternary: '#4A5060',
  colorBorder: '#262936',
  colorBorderSecondary: '#1B1D27',
  colorPrimary: '#5B9DEF',
  colorSuccess: '#34C77B',
  colorWarning: '#E0A33A',
  colorError: '#F0655F',
  colorInfo: '#5B9BF0',
};

export default { LIGHT_SEEDS, DARK_SEEDS };